export function getMapElementKey(spotType: string, spotName: string) {
  return `${spotType}-${spotName}`
}
